const locales = {
    'fi': {
        "error.getting.data": "Jotain meni vikaan haettaessa dataa.",
        "error.invalid.configuration": "Sovelluksen konfiguraatio on virheellinen.",
        "save": "Tallenna",
        "objective" : "Keino",
        "main.responsibility" : "Päävastuu",
        "part.responsibility" : "Osavastuu",
        "responsible.ministry" : "Vastuuministeriö",
        "schedule" : "Aikataulu",
        "previous.date" : "Aiempi aika",
        "new.date" : "Uusi aika",
        "ready" : "Valmistui",
        "to.be.ready" : "Valmistuu",
        "assignment.in.progress" : "Toteuttava hanke",
        "content.is.being.loaded" : "Sisältöä ladataan sivulle...",
        "open.menu" : "Avaa valikko",
        "close.menu" : "Sulje valikko",
        "show.more" : "Näytä lisää",
        "show.less" : "Näytä vähemmän",
        "list": "Lista",
        "change.to.list.view": "Vaihda listanäkymään",
        "timeline": "Aikajana",
        "change.to.timeline.view": "Vaihda aikajananäkymään",
        "milestone.completed": "Valmis",
        "timeline.zoom.in": "Zoomaa aikajanaa lähemmäs",
        "timeline.zoom.out": "Zoomaa aikajanaa kauemmas",
        "timeline.updated": "Päivitetty"
    },
    'en': {
        "error.getting.data": "Something went wrong while retrieving the data.",
        "error.invalid.configuration": "The application configuration is invalid.",
        "save": "Save",
        "objective" : "Action",
        "main.responsibility" : "Main responsibility",
        "part.responsibility" : "Partial responsibility",
        "responsible.ministry" : "Responsible ministry",
        "schedule" : "Schedule",
        "previous.date" : "Previous due date",
        "new.date" : "New due date",
        "ready" : "Completed on",
        "to.be.ready" : "To be completed",
        "assignment.in.progress" : "Implementing project",
        "content.is.being.loaded" : "Loading content to the page...",
        "open.menu" : "Open menu",
        "close.menu" : "Close menu",
        "show.more" : "Show more",
        "show.less" : "Show less",
        "list": "List",
        "change.to.list.view": "Switch to list view",
        "timeline": "Timeline",
        "change.to.timeline.view": "Switch to timeline view",
        "milestone.completed": "Completed",
        "timeline.zoom.in": "Zoom in the timeline",
        "timeline.zoom.out": "Zoom out the timeline",
        "timeline.updated": "Updated"
    },
    'sv': {
        "error.getting.data": "Något gick fel vid inhämtning av data.",
        "error.invalid.configuration": "Felaktig konfiguration i applikationen.",
        "save": "Spara",
        "objective" : "Metod",
        "main.responsibility" : "Huvudansvar",
        "part.responsibility" : "Delansvar",
        "responsible.ministry" : "Ansvarigt ministerium",
        "schedule" : "Tidsplan",
        "previous.date" : "Tidigare tid",
        "new.date" : "Ny tid",
        "ready" : "Avslutad",
        "to.be.ready" : "Avslutas",
        "assignment.in.progress" : "Genomförande projekt",
        "content.is.being.loaded" : "Innehållet laddas upp på sidan...",
        "open.menu" : "Öppna menyn",
        "close.menu" : "Stäng menyn",
        "show.more" : "Visa mer",
        "show.less" : "Visa mindre",
        "list": "List",
        "change.to.list.view": "Byt till listvy",
        "timeline": "Tidslinje",
        "change.to.timeline.view": "Byt till tidslinjevy",
        "milestone.completed": "Färdig",
        "timeline.zoom.in": "Zooma in tidslinjen",
        "timeline.zoom.out": "Zooma ut tidslinjen",
        "timeline.updated": "Uppdaterad"
    }
};

export default locales
